import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight',
})
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: string, keyword: string): SafeHtml {
    if (!keyword || !keyword.trim()) return value;

    const keywords = keyword
      .split(/\s+/)
      .map((k) => k.trim())
      .filter((k) => k.length > 0)
      .map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

    if (keywords.length === 0) return value;
    const re = new RegExp(`(${keywords.join('|')})`, 'gi');
    const highlighted = value.replace(re, '<span class="ig-highlight">$1</span>');
    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/pip/highlight.pipe.ts